import RequiredValidator from "@/validators/RequiredValidator";
import {BreakDurationValidator} from "@/validators/BreakDurationValidator";
import {NumberValidator} from "@/validators/NumberValidator";

export default class ReportRules {

	public static readonly orderIdRules = [
		(new RequiredValidator('order.singular')).validationRule(),
	];

	public static readonly userIdRules = [
		(new RequiredValidator('user.singular')).validationRule(),
	];

	public static readonly planningEntryIdRules = [
		(new RequiredValidator('planningEntry.singular')).validationRule(),
	];

	public static readonly dateRules = [
		(new RequiredValidator('report.date')).validationRule(),
	];

	public static readonly fromTimeRules = [
		(new RequiredValidator('report.fromTime')).validationRule(),
	];

	public static readonly toTimeRules = [
		(new RequiredValidator('report.toTime')).validationRule(),
	];

	public static breakDurationRules(timeFrom: string | null, timeTo: string | null) {
		return [
			(new RequiredValidator('report.breakDuration')).validationRule(),
			(new NumberValidator('report.breakDuration')).validationRule(),
			(new BreakDurationValidator('report.breakDuration', true, timeFrom, timeTo)).validationRule(),
		];
	}

	public static readonly licensePlateRules = [
		(new RequiredValidator('report.licensePlate')).validationRule(),
	];

}
